/**
 * Provides a monitoring interface for dashboard data refresh operations.
 * Retrieves and displays refresh status information for dashboard data sources,
 * enabling administrators to track refresh schedules, review last and next
 * refresh timestamps, and identify potential data synchronization issues.
 */
import React, { useEffect, useState } from "react";

import DataRefreshCenter from "./DataRefreshCenter";
import { getDataRefreshStatus } from "../../services/accessService";


interface RefreshItem {
  widgetName: string;
  tableName: string;
  Last_Refresh_Date: string;
  Next_Refresh_Date: string;
}

const DashboardMonitoring: React.FC = () => {
  const [data, setData] = useState<RefreshItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        const response = await getDataRefreshStatus();

        setData(response || []);
      } catch (err) {
        console.error(err);
        setError("Failed to load monitoring data");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  if (loading) {
    return (
      <div className="bg-[#f6f4ef] min-h-screen p-5">
        <div className="bg-white border border-gray-200 rounded-md p-6">
          <div className="text-center text-sm text-gray-500">
            Loading monitoring data...
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-[#f6f4ef] min-h-screen p-5">
        <div className="bg-white border border-red-200 rounded-md p-6">
          <div className="text-center text-red-600 text-sm">
            {error}
          </div>
        </div>
      </div>
    );
  }

  return <DataRefreshCenter items={data} />;
};

export default DashboardMonitoring;